export const UPLOADED_CUSTOM_UUID = "uploaded-hero-image-custom-uuid";